import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B1630] border-t border-white/10" data-testid="atlantis-footer">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-10 flex flex-col lg:flex-row items-center justify-between gap-6 text-center lg:text-left">
        <div>
          <div className="font-bold tracking-[0.06em] text-white text-lg">ATLANTIS INTERNATIONAL</div>
          <div className="text-sm text-[#64748B] mt-1">{t.footer.division}</div>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-8">
          {t.footer.links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={l.href === "#" ? (e) => e.preventDefault() : undefined}
              className="text-[15px] text-[#A3B1C6] hover:text-[#C5B358] transition-colors duration-200"
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="text-sm text-[#64748B]" data-testid="footer-copyright">
          © {year} Atlantis International. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
}